li.attribute-filter__item #{model.name}
